import { render, staticRenderFns } from "./ChatsPercentages.vue?vue&type=template&id=63b63f91&"
import script from "./ChatsPercentages.vue?vue&type=script&lang=js&"
export * from "./ChatsPercentages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports